<template>
  <div class="market-report">
    <!-- 顶部条件筛选 -->
    <div class="top-query-area">
      <!-- 媒体类型 -->
      <Select
        class="query-dimension"
        style="width: 160px"
        v-model="mediaType"
        :multiple="true"
        collapse-tags
        @change="queryTypeChanged('mediaType')"
        placeholder="请选择媒体类型"
      >
        <Option v-for="item in mediaTypeOptions" :key="item.value" :label="item.name" :value="item.value" />
      </Select>
      <!-- 资源位类型 -->
      <Select
        class="query-dimension"
        v-model="adslotType"
        :multiple="true"
        collapse-tags
        @change="queryTypeChanged('adslotType')"
        placeholder="请选择资源位类型"
      >
        <Option v-for="item in adslotTypeOptions" :key="item.value" :label="item.name" :value="item.value" />
      </Select>
      <!-- 销售团队 -->
      <Select
        class="query-dimension"
        style="width: 160px"
        v-model="saleType"
        v-if="saleTypeOptions.length > 0"
        :multiple="true"
        collapse-tags
        @change="queryTypeChanged('saleType')"
        placeholder="请选择销售团队"
      >
        <Option v-for="item in saleTypeOptions" :key="item.value" :label="item.name" :value="item.value" />
      </Select>
      <!-- 行业 -->
      <Cascader
        class="query-dimension"
        expand-trigger="hover"
        :options="categoryOptions"
        :props="categoryProps"
        :show-all-levels="false"
        collapse-tags
        placeholder="请选择行业"
        v-model="category"
      >
      </Cascader>
      <!-- 行业级别 -->
      <Select
        v-if="category.length"
        style="width: 120px"
        class="query-dimension"
        v-model="level"
        placeholder="请选择对比行业级别"
      >
        <Option v-for="item in categoryLevelOptions" :key="item.value" :label="item.name" :value="item.value" />
      </Select>
      <!-- 日期 -->
      <DatePicker
        class="datepicker"
        style="margin-right: 10px; margin-bottom: 20px"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        range-separator="-"
        v-model="timePeriod"
        :clearable="false"
        :picker-options="pickerOptions"
        @change="handleDateChange"
      />
      <Button :disabled="!queryBtnEnable" type="primary" plain style="margin-bottom: 20px" @click="queryReportData"
        >查询</Button
      >
    </div>
    <!-- chart图数据 -->
    <div class="chart-area">
      <Tabs v-model="chartTabType" type="border-card" class="tabs" @tab-click="handleTabsChange">
        <TabPane v-for="tab in chartTabs" :key="tab.name" :label="tab.label" :name="tab.name">
          <MarketChart
            v-if="tab.name === chartTabType"
            :type="chartTabType"
            :timePeriod="timePeriod"
            ref="marketChart"
          />
        </TabPane>
      </Tabs>
    </div>
    <!-- 表格数据 -->
    <div class="table-area">
      <!-- 汇总报表 -->
      <div class="report-all">
        <div class="title-bar">
          <Title text="大盘报表汇总" />
          <Checkbox v-model="detailChecked">显示明细表</Checkbox>
          <span style="float:right">
            <Button @click="handleCustomAllColumn" style="margin-right: 10px">自定义列</Button>
            <!-- <Button type="primary" @click="downloadSummary">下载汇总报表</Button> -->
            <DownloadReport
              topic="dashboard_summary"
              :args="downloadArgs1"
            />
          </span>
        </div>
        <div class="market-table">
          <Table
            border
            :data="summaryData"
            v-loading="summaryLoading"
            header-row-class-name="table-header"
            @sort-change="handleSummarySortChange"
          >
            <TableColumn
              v-for="item in summaryColumns"
              :key="item.key"
              :label="item.name"
              :prop="item.key"
              :sortable="item.sortable ? 'custom' : false"
              :fixed="item.fixed"
              :min-width="item.summaryWidth ? item.summaryWidth : 130"
            >
            </TableColumn>
          </Table>
        </div>
        <Pagination
          class="pagination"
          @size-change="handleSummaryPaginationSizeChange"
          @current-change="handleSummaryPaginationCurrentChange"
          :current-page="summaryPage"
          :page-sizes="[1, 10, 20, 30, 50, 100]"
          :page-size="summaryPageSize"
          layout="total, sizes, prev, pager, next"
          :total="summaryTotal"
        />
      </div>
      <!-- 详细报表 -->
      <div v-if="detailChecked" class="report-detail">
        <div class="title-bar">
          <Title text="大盘报表明细" />
          <span style="float:right">
            <Button @click="handleCustomDetailColumn" style="margin-right: 10px">自定义列</Button>
            <!-- <Button type="primary" @click="downloadDetail">下载明细报表</Button> -->
            <DownloadReport
              topic="dashboard"
              :args="downloadArgs2"
            />
          </span>
        </div>
        <div class="market-table">
          <Table
            border
            :data="detailData"
            v-loading="detailLoading"
            header-row-class-name="table-header"
            @sort-change="handleDetailSortChange"
          >
            <TableColumn
              v-for="item in detailColumns"
              :key="item.key"
              :label="item.name"
              :prop="item.key"
              :sortable="item.sortable ? 'custom' : false"
              :fixed="item.fixed"
              :min-width="item.detailWidth ? item.detailWidth : 130"
            >
              <template slot-scope="scope">
                <span v-if="!gainShow">{{ scope.row[item.key] }}</span>
                <span v-else>
                  {{ scope.row[item.key] }}
                  <br />
                  <span :style="getCellRateStyle(scope.row, item.key)">
                    {{ getCellRateLabel(scope.row, item.key) }}
                  </span>
                </span>
              </template>
            </TableColumn>
          </Table>
        </div>
        <Pagination
          class="pagination"
          @size-change="handleDetailPaginationSizeChange"
          @current-change="handleDetailPaginationCurrentChange"
          :current-page="detailPage"
          :page-sizes="[1, 10, 20, 30, 50, 100]"
          :page-size="detailPageSize"
          layout="total, sizes, prev, pager, next"
          :total="detailTotal"
        />
      </div>
    </div>
    <CustomColumn
      :defaultData="fieldColumns"
      :visible.sync="customAllColumnVisible"
      @confirm="handleCustomColumnConfirm"
    />
    <CustomColumn
      :defaultData="fieldColumns"
      :visible.sync="customDetailColumnVisible"
      @confirm="handleCustomColumnConfirm"
    />
  </div>
</template>

<script>
import {
  Button,
  Select,
  Cascader,
  DatePicker,
  Option,
  Tabs,
  TabPane,
  Checkbox,
  Table,
  TableColumn,
  Pagination
} from 'element-ui';
import Title from '@/components/Title';
import MarketChart from './components/MarketChart';
import moment from 'moment';
import Request from '@/core/QuRequest';
import * as $cache from '@/common/cache';
import { defaultFieldsList, targetFieldsList } from './config/';
import fixedColumn from './config/fixed_column';
import CustomColumn from './components/CustomColumn';
import DownloadReport from '@/components/DownloadReport/Index';

const req = new Request();
// 用户设置的自定义列信息
const MARKET_CUSTOM_TARGET_FIELDS = 'MARKET_CUSTOM_TARGET_FIELDS';

export default {
  name: 'MarketReport',
  components: {
    Button,
    Select,
    Cascader,
    DatePicker,
    Option,
    Tabs,
    TabPane,
    Checkbox,
    Table,
    TableColumn,
    Pagination,
    MarketChart,
    Title,
    CustomColumn,
    DownloadReport,
  },
  data() {
    return {
      mediaType: [-1],
      mediaTypeOptions: [],
      adslotType: [],
      adslotTypeOptions: [],
      saleType: [],
      saleTypeOptions: [],
      category: [],
      categoryOptions: [],
      categoryProps: {
        label: 'name',
        children: 'child',
        multiple: true
      },
      categoryLevelOptions: [
        {
          name: '一级行业',
          value: 1
        },
        {
          name: '二级行业',
          value: 2
        },
        {
          name: '三级行业',
          value: 3
        }
      ],
      level: 1,
      timePeriod: [
        moment()
          .subtract(7, 'day')
          .format('YYYY-MM-DD'),
        moment()
          .subtract(1, 'day')
          .format('YYYY-MM-DD')
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '昨天',
            onClick(picker) {
              picker.$emit('pick', [moment().subtract(1, 'day'), moment().subtract(1, 'day')]);
            }
          },
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', [moment(), moment()]);
            }
          },
          {
            text: '最近7天',
            onClick(picker) {
              picker.$emit('pick', [moment().subtract(7, 'day'), moment().subtract(1, 'day')]);
            }
          },
          {
            text: '最近30天',
            onClick(picker) {
              picker.$emit('pick', [moment().subtract(30, 'day'), moment().subtract(1, 'day')]);
            }
          },
          {
            text: '本周',
            onClick(picker) {
              picker.$emit('pick', [moment().weekday(1), moment().weekday(moment().weekday() - 1)]);
            }
          },
          {
            text: '上周',
            onClick(picker) {
              picker.$emit('pick', [moment().weekday(-6), moment().weekday(0)]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [moment().startOf('month'), moment()]);
            }
          },
          {
            text: '上个月',
            onClick(picker) {
              const lastMonth = moment().month() - 1;
              picker.$emit('pick', [
                moment()
                  .month(lastMonth)
                  .startOf('month'),
                moment()
                  .month(lastMonth)
                  .endOf('month')
              ]);
            }
          }
        ],
        disabledDate: function(date) {
          return moment(date).isAfter(moment().subtract(1, 'day'));
        }
      },
      chartTabType: 'media_type',
      chartTabs: [
        {
          label: '媒体类型',
          name: 'media_type'
        },
        {
          label: '资源位类型',
          name: 'adslot_type'
        },
        {
          label: '销售团队',
          name: 'sale_type'
        },
        {
          label: '行业',
          name: 'category'
        }
      ],
      detailChecked: false,
      customAllColumnVisible: false,
      customDetailColumnVisible: false,
      // 动态表单字段
      fieldColumns: this.getLocalTargets().columns || this.getDefaultFields().columns,
      summaryData: [],
      summaryObj: {},
      summaryPage: 1,
      summaryPageSize: 10,
      summaryTotal: 0,
      summaryLoading: false,
      detailData: [],
      detailObj: {},
      detailPage: 1,
      detailPageSize: 10,
      detailTotal: 0,
      detailLoading: false,
      summaryOrderBy: '',
      detailOrderBy: 'date desc'
    };
  },
  computed: {
    queryBtnEnable() {
      return this.mediaType.length || this.adslotType.length || this.saleType.length || this.category.length;
    },
    gainShow() {
      return this.fieldColumns.find(item => item.key === 'gain');
    },
    summaryColumns() {
      return fixedColumn
        .concat(this.fieldColumns.filter(item => item.key !== 'gain'))
        .filter(item => typeof this.summaryObj[item.key] !== 'undefined');
    },
    detailColumns() {
      return fixedColumn
        .concat(this.fieldColumns.filter(item => item.key !== 'gain'))
        .filter(item => typeof this.detailObj[item.key] !== 'undefined');
    },
    downloadArgs1() {
      let params = this.getTableParams();
      params.fields = this.summaryColumns.map((item) => item.key).join(',');
      params.order_by = this.summaryOrderBy;
      params._login_token = ($cache.localGet($cache.AUTH) || {}).token || '';
      return params;
    },
    downloadArgs2() {
      let params = this.getTableParams();
      params.fields = this.detailColumns.map((item) => item.key).join(',');
      params.order_by = this.detailOrderBy;
      params._login_token = ($cache.localGet($cache.AUTH) || {}).token || '';
      return params;
    },
  },
  created() {
    this.getQueryDimensions();
    this.getSummary();
    this.getDetail();
  },
  methods: {
    queryTypeChanged(type) {
      let val = this[type];
      if (val && val.length > 1 && val.includes(-1)) {
        this[type] = val.filter(item => item !== -1);
      }
    },
    async getQueryDimensions() {
      try {
        const res = await req.send(req.Apis.sales.report.queryDimensions, {});
        const allOpt = {
          name: '全部',
          value: -1
        };
        let dimensions = res.data;
        dimensions.forEach(item => {
          let hasData = item.options && item.options.length;
          if (item.key === 'media_type') {
            this.mediaTypeOptions = hasData ? [allOpt].concat(item.options) : [];
          }
          if (item.key === 'adslot_type') {
            this.adslotTypeOptions = hasData ? [allOpt].concat(item.options) : [];
          }
          if (item.key === 'sale_type') {
            this.saleTypeOptions = hasData ? [allOpt].concat(item.options) : [];
          }
          if (item.key === 'category') {
            this.categoryOptions = item.options;
          }
        });
        let showDimensions = dimensions.map(item => item.key);
        this.chartTabs = this.chartTabs.filter(item => showDimensions.includes(item.name));
      } catch (err) {
        this.$message.error(`获取查询维度失败：${err.message || '未知错误'}`);
      }
    },
    queryReportData() {
      this.getSummary();
      this.getDetail();
    },
    handleDateChange() {
      this.queryReportData();
    },
    handleTabsChange() {},

    // 显示自定义列对话框
    handleCustomAllColumn() {
      this.customAllColumnVisible = true;
    },

    // 显示自定义列对话框
    handleCustomDetailColumn() {
      this.customDetailColumnVisible = true;
    },
    // 获取默认自定列数据
    getDefaultFields() {
      const keys = [];
      const columns = defaultFieldsList.filter(field => {
        if (field.type === 'target') {
          keys.push(field.key);
        }
        return field.type === 'target';
      });

      const arr = columns.reduce((prev, current) => {
        if (current.branches) {
          return prev.concat(current.branches);
        } else {
          prev.push(current);
          return prev;
        }
      }, []);

      return { keys, columns: arr };
    },
    // 获取本地自定义列数据
    getLocalTargets() {
      const keys = $cache.localGet(MARKET_CUSTOM_TARGET_FIELDS);
      if (keys) {
        const columns = targetFieldsList.filter(field => keys.includes(field.key));
        return { keys, columns };
      }
      return {};
    },
    // 设置自定义列
    handleCustomColumnConfirm({ keys, columns }) {
      $cache.localSet(MARKET_CUSTOM_TARGET_FIELDS, keys);
      this.field = keys;
      this.fieldColumns = columns;
      this.getSummary();
      if (this.detailChecked) {
        this.getDetail();
      }
    },
    async getSummary() {
      try {
        if (!this.queryBtnEnable) return;
        this.summaryLoading = true;
        let params = this.getTableParams();
        params.order_by = this.summaryOrderBy;
        params.page = this.summaryPage;
        params.page_size = this.summaryPageSize;
        const res = await req.send(req.Apis.sales.report.summaryData, params);
        this.summaryData = res.data.list;
        // 取返回的列表数据第一项，筛选列表的colunm展示
        if (this.summaryData.length > 0) {
          this.summaryObj = this.summaryData[0];
        }
        this.summaryTotal = res.data.total;
        this.summaryLoading = false;
      } catch (err) {
        this.summaryLoading = false;
        this.$message.error(`获取汇总报表失败：${err.message || '未知错误'}`);
      }
    },
    async getDetail() {
      try {
        if (!this.queryBtnEnable) return;
        this.detailLoading = true;
        let params = this.getTableParams();
        params.order_by = this.detailOrderBy;
        params.page = this.detailPage;
        params.page_size = this.detailPageSize;
        const res = await req.send(req.Apis.sales.report.detailData, params);
        this.detailData = res.data.list;
        if (this.detailData.length > 0) {
          this.detailObj = this.detailData[0];
        }
        this.detailTotal = res.data.total;
        this.detailLoading = false;
      } catch (err) {
        this.detailLoading = false;
        this.$message.error(`获取详情报表失败：${err.message || '未知错误'}`);
      }
    },
    downloadSummary() {
      try {
        if (!this.queryBtnEnable) return;
        let params = this.getTableParams();
        params.fields = this.summaryColumns.map(item => item.key).join(',');
        params.order_by = this.summaryOrderBy;
        params._login_token = ($cache.localGet($cache.AUTH) || {}).token || '';
        const form = document.createElement('form');
        form.id = 'downloadForm';
        form.name = 'tableDownloadHelper';
        document.body.appendChild(form);
        for (let key in params) {
          if (params.hasOwnProperty(key)) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = params[key];
            form.appendChild(input);
          }
        }
        form.method = 'POST';
        form.action = req.getUrl(req.Apis.sales.report.summaryDownload);
        form.submit();
        document.body.removeChild(form);
      } catch (err) {
        this.$message.error(`下载汇总报表失败：${err.message || '未知错误'}`);
      }
    },
    downloadDetail() {
      try {
        if (!this.queryBtnEnable) return;
        let params = this.getTableParams();
        params.fields = this.detailColumns.map(item => item.key).join(',');
        params.order_by = this.detailOrderBy;
        params._login_token = ($cache.localGet($cache.AUTH) || {}).token || '';
        const form = document.createElement('form');
        form.id = 'downloadForm';
        form.name = 'tableDownloadHelper';
        document.body.appendChild(form);
        for (let key in params) {
          if (params.hasOwnProperty(key)) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = params[key];
            form.appendChild(input);
          }
        }
        form.method = 'POST';
        form.action = req.getUrl(req.Apis.sales.report.detailDownload);
        form.submit();
        document.body.removeChild(form);
      } catch (err) {
        this.$message.error(`下载详细报表失败：${err.message || '未知错误'}`);
      }
    },
    getTableParams() {
      let params = {
        start_date: moment(this.timePeriod[0]).format('YYYY-MM-DD'),
        end_date: moment(this.timePeriod[1]).format('YYYY-MM-DD'),
        media_type: this.mediaType.join(','),
        adslot_type: this.adslotType.join(','),
        category: this.category
          .reduce((accumulator, currentValue) => {
            return accumulator + currentValue.join(':') + ',';
          }, '')
          .slice(0, -1),
        needStringify: true
      };
      if (this.saleTypeOptions.length > 0) {
        params.sale_type = this.saleType.join(',');
      }
      if (this.category.length > 0) {
        params.level = this.level;
      }
      return params;
    },
    getCellRateStyle(row, key) {
      let rate = key + '_add_rate';
      if (typeof row[rate] === 'undefined') return {};
      // 去除rate最后的百分号
      let value = row[rate].slice(0, -1);
      if (value) {
        return Number(value) > 0 ? { color: 'red' } : { color: 'green' };
      } else {
        return {};
      }
    },
    getCellRateLabel(row, key) {
      let rate = key + '_add_rate';
      if (typeof row[rate] === 'undefined') return '';
      // 去除rate最后的百分号
      let value = row[rate].slice(0, -1);
      if (value) {
        return Number(value) > 0 ? `(+${row[rate]})` : `(${row[rate]})`;
      } else {
        return '(-)';
      }
    },
    handleSummarySortChange({ column, order, prop }) {
      this.summaryOrderBy = order === 'ascending' ? prop + ' asc' : prop + ' desc';
      this.getSummary();
    },
    handleDetailSortChange({ column, order, prop }) {
      this.detailOrderBy = order === 'ascending' ? prop + ' asc' : prop + ' desc';
      this.getDetail();
    },
    handleSummaryPaginationSizeChange(size) {
      this.summaryPageSize = size;
      this.getSummary();
    },
    handleSummaryPaginationCurrentChange(current) {
      this.summaryPage = current;
      this.getSummary();
    },
    handleDetailPaginationSizeChange(size) {
      this.detailPageSize = size;
      this.getDetail();
    },
    handleDetailPaginationCurrentChange(current) {
      this.detailPage = current;
      this.getDetail();
    }
  }
};
</script>
<style lang="less" scoped>
.market-report {
  .top-query-area {
    .query-dimension {
      margin-right: 24px;
      margin-bottom: 24px;
    }
    .query-btn {
      margin-bottom: 24px;
    }
  }
  .table-area {
    .title-bar {
      margin-top: 50px;
      .cm-title {
        display: inline-block;
        padding-right: 24px;
      }
    }
    .market-table {
      margin-top: 34px;
      /deep/ .table-header {
        th {
          background: rgba(242, 249, 255, 1);
        }
      }
    }
    .report-detail {
      margin-top: 75px;
    }
    .pagination {
      float: right;
      margin-top: 20px;
    }
  }
}
</style>
